import React, { useState, useEffect } from 'react';
import Dropdown from '../components/Dropdown';
import { useDispatch, useSelector } from 'react-redux';
import Cross from '@material-ui/icons/Close';
import nabeel from '../assets/nabeel4.png';
import ArrowRight from '@material-ui/icons/ArrowRight';
import ArrowDown from '@material-ui/icons/ArrowDropDown';
import { setNeeds, addNeedsToFirestore } from '../redux/actions/needsActions';
import {
  food,
  babyThings,
  healthThings,
  household,
  clothes,
  prov,
} from '../redux/constants';
import OlMaol from '../components/OlMap';
export default function RequestNeeds() {
  const dispatch = useDispatch();
  const [needsData, setNeedsData] = useState({
    fullName: '',
    phoneNumber: '',
    prov: 'حدد محافظتك',
    location: '',
    needs: useSelector((state) => state.needsReducer.needs),
    cardStatus: 'pending',
    workerCard: [],
    workerCardTime: {},
  });
  const [OpenRequestModel, setOpenRequestModel] = useState(false);
  const [openProv, setOpenProv] = useState(false);
  const chooseProv = (value) => {
    setNeedsData({
      ...needsData,
      prov: value,
    });
    setOpenProv(!openProv);
  };
  const handleChange = (event) => {
    if (event.target.name === 'phoneNumber') {
      let phoneno = /^\d{11}$/;
      event.target.value.match(phoneno)
        ? setNeedsData({
            ...needsData,
            [event.target.name]: event.target.value,
          })
        : setNeedsData({
            ...needsData,
            [event.target.name]: ' ',
          });
    }
    setNeedsData({
      ...needsData,
      [event.target.name]: event.target.value,
    });
  };
  const MakeSureModel = () => {
    setOpenRequestModel(!OpenRequestModel);
  };
  const handleClick = (item) => {
    if (!needsData.needs.some((current) => current.id === item.id)) {
      setNeedsData({ ...needsData, needs: [...needsData.needs, item] });
    } else {
      let selectionAfterRemoval = needsData.needs;
      selectionAfterRemoval = selectionAfterRemoval.filter(
        (current) => current.id !== item.id
      );
      setNeedsData({ ...needsData, needs: [...selectionAfterRemoval] });
    }
  };
  const isItemSelected = (item) => {
    if (needsData.needs.find((current) => current.id === item.id)) {
      return true;
    }
    return false;
  };
  useEffect(() => {
    dispatch(setNeeds(needsData.needs));
  }, [needsData.needs, dispatch]);
  const handleSubmit = (e, needsData) => {
    e.preventDefault();
    if (
      needsData.prov.length >= 1 &&
      needsData.prov !== 'حدد محافظتك' &&
      needsData.location.length >= 1 &&
      needsData.needs.length >= 1
    ) {
      dispatch(addNeedsToFirestore(needsData));
      setNeedsData({
        fullName: '',
        phoneNumber: '',
        prov: 'حدد محافظتك',
        location: '',
        needs: [],
      });
      MakeSureModel();
      alert('تم ارسال المعلومات');
    } else {
      alert('يجب ملئ جميع الحقول بشكل صحيح ليتم الارسال');
    }
  };

  const passLocation = (loc) => {
    setNeedsData({
      ...needsData,
      location: loc,
    });
  };
  return (
    <div className='footer-low'>
      <div className='signin-bg lg:p-24 m-10 lg:m-0'>
        <div className='w-full bg-white lg:bg-transparent'>
          <div className='md:flex md:justify-center md:mt-4 md:pb-10 pb-16 flex flex-col justify-center items-center content-center'>
            <div
              className='sign-back md:border-2 md:rounded-lg  p-4 w-4/5 h-4/5
            flex flex-col items-center  md:flex-none md:items-end
            '
            >
              <div className='flex justify-center  pb-16 md:hidden '>
                <img src={nabeel} alt='Logo' />
              </div>
              <div className='md:flex md:justify-end text-center '>
                <p className='text-sm text-gray-800'>
                  قم بتسجيل معلوماتك واحتيجاتك لتصلك المساعدة
                </p>
              </div>
              <div className='hidden md:block md:flex md:justify-end pr-12'></div>

              <form
                onSubmit={(e) => handleSubmit(e, needsData)}
                className='md:w-full'
              >
                <div className='flex flex-col md:flex-row md:justify-end w-full'>
                  <input
                    name='phoneNumber'
                    type='phoneNumber'
                    onChange={handleChange}
                    value={needsData.phoneNumber}
                    className='order-2 md:order-1 w-64  border-2 rounded-lg focus:outline-none text-black px-2 text-right py-1 m-2'
                    placeholder='رقم الهاتف'
                    required
                  />
                  <input
                    name='fullName'
                    type='text'
                    onChange={handleChange}
                    value={needsData.fullName}
                    className='order-1 md:order-2 w-64 border-2 rounded-lg focus:outline-none text-black px-2 text-right py-1 m-2'
                    placeholder='الاسم الثلاثي'
                    required
                  />
                </div>
                <div className='flex flex-col md:flex-row md:justify-end'>
                  <div className='w-full h-full m-2 order-2 md:order-first overflow-hidden'>
                    <OlMaol passLocation={passLocation} />
                  </div>

                  <div className='flex flex-col'>
                    <div className='focus:outline-none  w-64 m-2'>
                      <div
                        className=' flex  justify-between items-center border rounded-lg n-blue  px-4 focus:outline-none'
                        tabIndex={0}
                        role='button'
                        onClick={() => {
                          setOpenProv(!openProv);
                        }}
                      >
                        <div>
                          <p className='pr-4'>{needsData.prov}</p>
                        </div>

                        {openProv ? (
                          <ArrowDown
                            style={{ fontSize: 40, color: 'blue-400' }}
                            alt='arrow'
                          />
                        ) : (
                          <ArrowRight
                            style={{ fontSize: 40, color: 'blue-400' }}
                            alt='arrow'
                          />
                        )}
                      </div>
                      {openProv && (
                        <div className=' h-32 overflow-y-scroll scrolling-touch overflow-x-hidden z-50 scrollbar-thumb'>
                          <ul className='border-2 rounded-lg n-blue bg-white'>
                            {prov.map((item) => {
                              return (
                                <li
                                  key={item.id}
                                  className='border-b-2 n-blue  px-4 py-2 focus:outline-none'
                                >
                                  <div
                                    type='button'
                                    onClick={() => chooseProv(item.value)}
                                    className=' flex justify-between cursor-pointer'
                                  >
                                    <span>{item.value}</span>
                                  </div>
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      )}
                    </div>

                    <div>
                      <p className='text-sm text-gray-800 text-center'>
                        اختر احتياجاتك
                      </p>
                      <Dropdown
                        title='مواد غذائية'
                        items={food}
                        handleClick={handleClick}
                        isItemSelected={isItemSelected}
                      />
                      <Dropdown
                        title='اطفال'
                        items={babyThings}
                        handleClick={handleClick}
                        isItemSelected={isItemSelected}
                      />
                      <Dropdown
                        title='مواد صحية'
                        items={healthThings}
                        handleClick={handleClick}
                        isItemSelected={isItemSelected}
                      />
                      <Dropdown
                        title='ملابس'
                        items={clothes}
                        handleClick={handleClick}
                        isItemSelected={isItemSelected}
                      />
                      <Dropdown
                        title='مواد منزلية'
                        items={household}
                        handleClick={handleClick}
                        isItemSelected={isItemSelected}
                      />
                    </div>
                  </div>
                </div>
                <div className='m-4 flex justify-center content-center items-center '>
                  <button
                    name='submit'
                    type='button'
                    className=' bg-n-blue border text-white rounded-lg p-2 focus:outline-none '
                    onClick={MakeSureModel}
                  >
                    <div className='tooltip'>
                      ارسال المعلومات
                      <span className='tooltiptext'>
                        تأكد من معلوماتك قبل الارسال
                      </span>
                    </div>
                  </button>
                </div>
                <div
                  className={`w-full h-full bg-model fixed top-0 left-0 justify-center items-center z-40 ${
                    OpenRequestModel ? 'flex' : 'hidden'
                  } `}
                >
                  <div className='  md:w-2/5 md:h-75 model-res bg-white md:rounded-lg p-4 md:relative'>
                    <div className=' flex justify-end model-p text-lg'>
                      <Cross
                        className='cursor-pointer'
                        onClick={MakeSureModel}
                        width='20'
                        height='20'
                        alt='exsit'
                      />
                    </div>
                    <div className=' flex justify-center model-p text-lg'>
                      تأكيد المعلومات
                    </div>
                    <div className='pt-2'>
                      <p className='text-center pt-2'>الأسم</p>
                      <div className='flex justify-center'>
                        <span className=' w-64 h-8 bg-gray-300 rounded-lg text-center p-1'>
                          {needsData.fullName}
                        </span>
                      </div>
                    </div>
                    <div className='pt-2'>
                      <p className='text-center pt-2'>رقم الهاتف</p>
                      <div className='flex justify-center'>
                        <span className=' w-64 h-8 bg-gray-300 rounded-lg text-center p-1'>
                          {needsData.phoneNumber}
                        </span>
                      </div>
                    </div>
                    <div className='pt-2'>
                      <p className='text-center pt-2'>المحافظة</p>
                      <div className='flex justify-center'>
                        <span className=' w-64 h-8 bg-gray-300 rounded-lg text-center p-1'>
                          {needsData.prov}
                        </span>
                      </div>
                    </div>
                    <div className='pt-2'>
                      <p className='text-center pt-2'>الإحتياجات</p>
                      <div className='flex justify-center'>
                        <span className=' w-64 h-32 bg-gray-300 rounded-lg text-center p-1'>
                          {needsData.needs ? (
                            needsData.needs.map((item) => (
                              <span key={item.id} className='inline-block m-1'>
                                ,{item.value}
                              </span>
                            ))
                          ) : (
                            <span>لم تختر احتياجاتك</span>
                          )}
                        </span>
                      </div>
                    </div>
                    <div className='flex justify-center p-8'>
                      <button
                        name='submit'
                        type='submit'
                        className='blue-bg border text-white rounded-lg p-2 w-32 text-sm focus:outline-none'
                      >
                        ارسال المعلومات
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
